import React, { ReactElement } from "react";
import Avatar from "../../avatar";

const ClubItemLarge = ({
	name,
	meta,
	photoUrl,
	availability,
	extraClass = "",
	dimension = "thumb6",
}: {
	name: string;
	meta: string;
	photoUrl: string;
	availability: ReactElement;
	extraClass?: string;
	dimension?: string;
}) => (
	<div className={`item club large ${extraClass}`}>
		{photoUrl ? (
			<div className="itemImage">
				<Avatar className="club" photoUrl={photoUrl} size={dimension} />
			</div>
		) : null}
		<div className="itemBody">
			<div className="title">{name}</div>
			<div className="meta">
				<div className="longTextWrap">
					<div className="longText">{meta}</div>
				</div>
			</div>
			<div className="availability">{availability}</div>
		</div>
	</div>
);

export default ClubItemLarge;
